import React from 'react';
export default function DisplayList({ children, small = false }) { const classes = ['display-list']; if (small) {
    classes.push('display-list--small');
} return /*#__PURE__*/ React.createElement("div", { className: classes.join(' ') }, children); }
